import { sortTypes } from './sort.types';
import { sorter } from '../sorter';

var sortByCategory = function sortByCategory(data, categoryField) {
    return sorter.sortObjArrayByValue(data, false, categoryField);
};

var sortByDate = function sortByDate(data, dateField) {
    return sorter.sortObjArrayByDate(data, false, dateField);
};

var sortBySortOrder = function sortBySortOrder(data, orderField, inverseSort) {
    return sorter.sortBySortOrder(data, orderField, inverseSort);
};

var sortByFirstSeries = function sortByFirstSeries(data, valueField, allData) {};

var sortBySumOfSeries = function sortBySumOfSeries(data, valueField, allData, categoryField) {
    var sums = {};
    Object.keys(allData).forEach(function (series) {
        var seriesData = allData[series];

        seriesData.forEach(function (data) {
            var value = data[valueField];

            sums[data[categoryField]] = (sums[data[categoryField]] || 0) + (value || 0);
        });
    });

    var categoryOrder = Object.keys(sums).sort(function (a, b) {
        return sums[b] - sums[a];
    });

    var sorted = sortByCategoryOrder(data, categoryField, categoryOrder);
    return sorted;
};

var sortByValue = function sortByValue(data, valueField) {
    return sorter.sortObjArrayByValue(data, false, valueField);
};

/**
 *
 * @param {Array} data - data objects to be sorted
 * @param {string} categoryField - field in each data objected that holds the category
 * @param {string[]} categoryOrder - array of ordered categories
 */
var sortByCategoryOrder = function sortByCategoryOrder(data, categoryField, categoryOrder) {
    data = [].concat(data);

    return data.sort(function (a, b) {
        var aString = a[categoryField] == null ? '' : a[categoryField].toString();
        var bString = b[categoryField] == null ? '' : b[categoryField].toString();
        var aIndex = categoryOrder.findIndex(function (category) {
            return (category == null ? '' : category.toString()) === aString;
        });
        var bIndex = categoryOrder.findIndex(function (category) {
            return (category == null ? '' : category.toString()) === bString;
        });

        return aIndex - bIndex;
    });
};

/**
 *
 * @param {sortTypes} sortType - type of sort to apply
 * @param {Object[]} data - data to be sorted
 * @param {string} field - name of the field to sort on
 * @param {Object} seriesDataObj - object with all series data keyed by series name
 * @param {string} categoryField - name of the category field for the chart
 */
export var sort = function sort(sortType, data, field, seriesDataObj, categoryField, categoryOrder, orderField) {
    switch (sortType) {
        case sortTypes.CATEGORY:
            return sortByCategory(data, field);
        case sortTypes.DATE:
            return sortByDate(data, field);
        case sortTypes.VALUE:
            return sortByValue(data, field);
        case sortTypes.SORT_ORDER:
            return sortBySortOrder(data, orderField);
        case sortTypes.FIRST_SERIES:
            return sortByCategoryOrder(data, categoryField, categoryOrder);
        case sortTypes.SUM_OF_SERIES:
            return sortBySumOfSeries(data, field, seriesDataObj, categoryField);
        case sortTypes.NONE:
            return data;
        default:
    }
};